import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import styles from "./Header.module.css";

import LanguageSwitcher from "./LanguageSwitcher";
import ThemeSwitcher from "../ThemeSwitcher/ThemeSwitcher";


export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const toggleMenu = () => setIsOpen((prev) => !prev);
    const closeMenu = () => setIsOpen(false);


    return (
        <div className={styles.navbarWrapper}>
            <button className={styles.burger} onClick={toggleMenu} aria-label="Toggle menu">
                ☰
            </button>

            {isOpen && (
                <div className={styles.overlay} onClick={closeMenu}>
                    <div className={styles.drawer} onClick={(e) => e.stopPropagation()}>
                        <button className={styles.close} onClick={closeMenu} aria-label="Close menu">
                            ✕
                        </button>

                        <nav className={styles.drawerNav}>
                            <Link to="/surveys" className={styles.link} onClick={closeMenu}>
                                {t("header.surveys")}
                            </Link>
                            <Link to="/about" className={styles.link} onClick={closeMenu}>
                                {t("header.about")}
                            </Link>
                            <Link to="/results" className={styles.link} onClick={closeMenu}>
                                {t("header.results")}
                            </Link>
                            <Link to="/privacy" className={styles.link} onClick={closeMenu}>{t("footer.privacy")}</Link>
                        </nav>
                        <div className={styles.mobileLang}>
                            <ThemeSwitcher />
                            <LanguageSwitcher />
                        </div>

                    </div>
                </div>
            )}

            <nav className={styles.desktopNav}>
                <Link to="/surveys" className={styles.link}>{t("header.surveys")}</Link>
                <Link to="/about" className={styles.link}>{t("header.about")}</Link>
                <Link to="/privacy" className={styles.link}>{t("footer.privacy")}</Link>
                <Link to="/results" className={styles.link}>{t("header.results")}</Link>

                <div className={styles.desktopLang}>
                    <ThemeSwitcher />
                    <LanguageSwitcher />
                </div>
            </nav>
        </div>
    );
}
